import {v4 as uuidv4} from 'uuid';
import {ConsentCategory, hasConsent} from './consent';

export enum categories {
    initialLanding = 'initial landing',
    intentGoals = 'basic-intent_goals',
    intentGrow = 'basic-intent_grow',
    intentProtect = 'basic-intent_protect',
    intentCashValue = 'basic-intent_grow_cash_value',
    intentInvestmentVehicles = 'basic-intent_grow_investment_vehicles',
    intentTaxAdvantagedAccounts = 'basic-intent_grow_tax_advantaged_accounts',
    intentEmergencyFund = 'basic-intent_grow_emergency_fund',
    intentDependents = 'basic-intent_protect_dependents',
    intentChildren = 'basic-intent_protect_children',
    intentMortgage = 'basic-intent_protect_mortgage',
    intentLivingBenefitCoverage = 'basic-intent_protect_living_benefit_coverage',
    intentRecommendation = 'basic-intent_interstitial_recommendation',
    intentGoals2026 = 'basic-intent_goals_2026', // ENG-4456
    intentGrow2026 = 'basic-intent_grow_2026', // ENG-4456
    intentFundingPlan = 'basic-intent_funding_plan', // ENG-4456
    intentProtect2026 = 'basic-intent_protect_2026', // ENG-4456
    intentProtectionNeeds = 'basic-intent_protection_needs', // ENG-4456
    intentProtectCoverage = 'basic-intent_protect_coverage', // ENG-4456
    intentCoverageType = 'basic-intent_coverage_type', // ENG-4456
    intentCashValueImportance = 'basic-intent_cash_value_importance', // ENG-4456
    intentCustomerSelectedAnnuity = 'basic-intent_customer_selected_annuity', // ENG-4456
    intentCustomerSelectedFE = 'basic-intent_customer_selected_fe', // ENG-4456
    intentCustomerSelectedADB = 'basic-intent_customer_selected_adb', // ENG-4456
    overallHealth = 'over all health',
    takePlan = 'plan that takes care',
    takeFeature = 'Features in life insurance',
    startIntent = 'Intent to buy life insurance',
    investmentRisk = 'Investment Risk',
    birthDate = 'Date of birth',
    gender = 'Gender',
    zipcode = 'Zipcode',
    address = 'basic-address',
    incomeOccupation = 'Income & occupation',
    estimatedSavingTotal = 'Estimated Savings Total',
    estimatedDebtTotal = 'Estimated Debt Total',
    budget = 'Monthly budget',
    employmentStatus = 'basic-employment-status',
    treatment = 'treatment due to substance abuse or detoxification',
    treatmentDetails = 'treatment-details',
    alcoholDrugFree = 'alcohol or drug-free',
    alcoholicBeverages = 'alcoholic-beverages',
    drinksWeekly = 'health-drinking-frequency',
    health1stSlide = 'Next step',
    healthFamilyMedical = 'health-family-medical',
    smoke = 'Smoker',
    selectIllness = 'Health',
    selectAnyCondition = 'Any condition',
    driving = 'Driving',
    criminalOffense = 'Criminal Offense',
    bankruptcy = 'Bankruptcy',
    preQuotes = 'PreQuotes',
    quotes = 'Quotes',
    preApproval = 'Pre-approval',
    scheduleTime = 'Schedule time',
    family = 'Family life insurance',
    primaryCare = 'health-primary-physician',
    thankYou = 'Thank you',
    aids = 'health-hiv-aids',
    military = 'basic-military-organization',
    existingCoverage = 'basic-annuities',
    travellingOut = 'basic-international-travel',
    extremeSports = 'basic-extreme-activities',
    birthCountry = 'basic-born-location',
    usCitizen = 'basic-citizenship',
    maritalStatus = 'basic-marital-status',
    numberOfChildren = 'Number of Children',
    heightWeight = 'Height Weight',
    landing = 'Landing',
    leadForm = 'LeadForm',
    routeChangeComplete = 'routeChangeComplete',
    any = '',
    name = 'name',
    email = 'email',
    referralSource = 'referralSource',
    prosperFlowChecklist = 'single-page-KO-screen',
}
export enum actions {
    nextBtn = 'Click Next button',
    backBtn = 'Click Back button',
    pageView = 'Page view',
    getApproved = 'Click Get Approved button',
    getPreApproved = 'cp-get-approved-complete',
    submitBtn = 'Click submit button',
    homePageBtn = 'Click home page button',
    land = 'Land on the page',
    quotesWeAreSorry = 'quotes-we-are-sorry',
    routeChange = 'routeChange',
    logoClicked = 'wt-headerLogo-clicked',
    emailIconClicked = 'wt-headerEmailIcon-clicked',
    phoneIconClicked = 'wt-headerPhoneIcon-clicked',
    dobHelperClicked = 'wt-basic-dateOfBirth-helper-clicked',
    householdIncomeTitleInfoClicked = 'wt-basic-annualHouseholdIncome-householdTitleInfo-clicked',
    personalIncomeTitleInfoClicked = 'wt-basic-annualHouseholdIncome-personalTitleInfo-clicked',
    monthlyAmountSliderChanged = 'wt-basic-comfortableAmount-amountSlider-changed',
    recommendedProductTabClicked = 'wt-quotes-recommendation-recommendedProductTab-clicked',
    recommendationTitleInfoClicked = 'wt-quotes-recommendation-recommendationTitleInfo-clicked',
    recommendationInfoTextReadMoreClicked = 'wt-quotes-recommendation-recommendationInfoTextReadMore-clicked',
    recommendationCoverageAmountSliderSlid = 'wt-quotes-recommendation-coverageAmountSlider-slid',
    recommendationCoverageAmountSliderInfoClicked = 'wt-quotes-recommendation-coverageAmountSliderInfo-clicked',
    policyCardEstCashCardInfoClicked = 'wt-quotes-recommendation-policyCardEstCashCardInfo-clicked',
    policyCardMonthlyPremiumInfoClicked = 'wt-quotes-recommendation-policyCardMonthlyPremiumInfo-clicked',
    policyCardFloorLossInfoClicked = 'wt-quotes-recommendation-policyCardFloorLossInfo-clicked',
    policyCardHowButtonClicked = 'wt-quotes-recommendation-policyCardHowButton-clicked',
    pageViewUnder50 = 'page_view_under_50',
    pageViewUnder50AndHHIGreaterThan35000 = 'page_view_under_50_and_hhi_greater_than_35000',
    quotesReferralSource = 'wt-quotes-referralSource',
    quoteshowDoesItWorkUpdatedIUL = 'wt-quotes-howDoesItWork-updatedIUL',
    landingLeadFormView = 'wt_landing_lead_form_view',
}

enum events {
    commonEvent = 'common_event',
}

export enum eventsCustom {
    finishWalkthrough = 'finish_walkthrough',
    submitContactForm = 'submit_contact_form',
    addFullname = 'add_fullname',
    openChat = 'openChat',
}

/**
 * Categories whose names reveal what the visitor was asked about their health.
 *
 * The dataLayer is read by GTM and forwarded to whichever tags are listening — at present
 * that includes two session recorders and several advertising vendors. "This browser reached
 * the HIV/AIDS question" is consumer health data tied to an advertising identifier, which is
 * the pattern behind the FTC's GoodRx and BetterHelp actions, and Washington's My Health My
 * Data Act treats collecting it as requiring opt-in consent.
 *
 * These events are still worth having for funnel analysis, so the event fires with the topic
 * replaced rather than being dropped.
 */
const HEALTH_CATEGORIES: ReadonlySet<categories> = new Set([
    categories.aids,
    categories.alcoholDrugFree,
    categories.alcoholicBeverages,
    categories.drinksWeekly,
    categories.healthFamilyMedical,
    categories.heightWeight,
    categories.overallHealth,
    categories.selectAnyCondition,
    categories.selectIllness,
    categories.smoke,
    categories.treatment,
    categories.treatmentDetails,
]);

const REDACTED_HEALTH_CATEGORY = 'health-question';

/**
 * Whether an event may enter the dataLayer.
 *
 * This is what makes GTM forward-only. Termly creates `window.dataLayer` long before GTM,
 * and GTM replays whatever it finds there when it initialises — so pushing pre-consent would
 * backfill the whole visit into every tag the moment someone accepts. Counsel asked for
 * post-consent events only, so we never write them in the first place rather than trying to
 * clear the array afterwards.
 *
 * Termly's own consent signals use its own code path and are unaffected.
 */
const mayPushToDataLayer = (): boolean => hasConsent(ConsentCategory.analytics);

export const pushEvent = (category: categories, action: actions, payload?: any): void => {
    if (!mayPushToDataLayer()) return;

    const isHealthTopic = HEALTH_CATEGORIES.has(category);

    window?.dataLayer?.push({
        event: events.commonEvent,
        eventId: uuidv4(),
        custom_category: isHealthTopic ? REDACTED_HEALTH_CATEGORY : category,
        custom_action: action,
        // Dropped alongside the category — no health event should carry answer data onward,
        // including from call sites added later.
        data_layer_payload: isHealthTopic ? undefined : payload,
    });
};

export const pushCustomEvent = (event: eventsCustom | string, payload?: any): void => {
    if (!mayPushToDataLayer()) return;

    window?.dataLayer?.push({
        event: event,
        eventId: uuidv4(),
        data_layer_payload: payload,
    });
};
